import { useEffect, useState } from "react";

export default function Countdown({ target }) {
  const [t, setT] = useState({ d: 0, h: 0, m: 0, s: 0 });
  useEffect(() => {
    if (!target) return;
    const tick = () => {
      const diff = Math.max(0, new Date(target).getTime() - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setT({ d, h, m, s });
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [target]);
  const Box = ({ v, l }) => (
    <div data-testid={`countdown-${l}`} className="min-w-[80px] md:min-w-[110px] px-4 py-4 md:py-6 bg-[#0B132B] border border-white/10 text-center flicker">
      <div className="font-display text-4xl md:text-6xl text-[#39FF14]">{String(v).padStart(2, "0")}</div>
      <div className="text-[10px] md:text-xs tracking-[0.3em] text-white/60 uppercase mt-1">{l}</div>
    </div>
  );
  return (
    <div className="flex flex-wrap gap-3 md:gap-4 justify-center" data-testid="countdown-timer">
      <Box v={t.d} l="days" /><Box v={t.h} l="hrs" /><Box v={t.m} l="min" /><Box v={t.s} l="sec" />
    </div>
  );
}
